"use client";

import React from "react";
import {PageLeaderboardsSchema} from "@/sanity/pages/PageLeaderboardsTemplate";

import DecorationLine from "@/components/global/ui/DecorationLine";
import Chip from "@/components/global/ui/Chip";
import UnicornEmbedWrapper from "@/components/global/utils/UnicornEmbedWrapper";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";

import watchFallback from "@/public/leaderboards/watch-fallback.png";

export default function CashbackSection({
  data,
  className,
}: {
  data: PageLeaderboardsSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative overflow-clip py-[7rem] lg:py-[17rem]",
        className
      )}
    >
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="left"
      />
      <DecorationLine
        className="top-0"
        orientation="vertical"
        position="right"
      />

      <div className="container relative flex flex-col items-center">
        <div className="w-[min(187.75rem,100%)] flex flex-col lg:flex-row gap-[4rem] lg:gap-[7rem]">
          <div className="w-full lg:w-auto lg:grow relative aspect-[1200/750]">
            <UnicornEmbedWrapper
              assetID="u91X6hVmXi4txft17q8t"
              placeholderImage={watchFallback}
              placeholderCover={true}
            />
          </div>

          <div className="w-full lg:w-[53.5rem] flex-shrink-0">
            <Chip
              image={data?.cashbackChip?.icon}
              text={data?.cashbackChip?.text}
            />

            {data?.cashbackText && (
              <div className="richtext text-start lg:prose-p:pe-[10rem] prose-headings:mb-0 prose-headings:text-start items-start prose-p:mt-[2rem] lg:prose-p:mt-[4rem]">
                <PortableText
                  value={data.cashbackText}
                  components={richTextComponent}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
